import type { RequestHandler as RH, RESTPostAPIAttachmentsRefreshURLsResult } from "../RequestHandler";
import type ST = require("../SnowTransfer");

import Endpoints = require("../Endpoints");
import Constants = require("../Constants");

import {
	type APITextBasedChannel,
	type APIThreadChannel,
	type ChannelType,
	type RESTDeleteAPIChannelAllMessageReactionsResult,
	type RESTDeleteAPIChannelMessageReactionResult,
	type RESTDeleteAPIChannelMessageResult,
	type RESTDeleteAPIChannelMessageUserReactionResult,
	type RESTDeleteAPIChannelPermissionResult,
	type RESTDeleteAPIChannelPinResult,
	type RESTDeleteAPIChannelResult,
	type RESTDeleteAPIChannelThreadMembersResult,
	type RESTGetAPIChannelInvitesResult,
	type RESTGetAPIChannelMessageReactionUsersQuery,
	type RESTGetAPIChannelMessageReactionUsersResult,
	type RESTGetAPIChannelMessageResult,
	type RESTGetAPIChannelMessagesQuery,
	type RESTGetAPIChannelMessagesResult,
	type RESTGetAPIChannelPinsResult,
	type RESTGetAPIChannelResult,
	type RESTGetAPIChannelThreadMemberResult,
	type RESTGetAPIChannelThreadMembersQuery,
	type RESTGetAPIChannelThreadMembersResult,
	type RESTGetAPIChannelThreadsArchivedPrivateResult,
	type RESTGetAPIChannelThreadsArchivedPublicResult,
	type RESTGetAPIChannelThreadsArchivedQuery,
	type RESTGetAPIChannelUsersThreadsArchivedResult,
	type RESTPatchAPIChannelJSONBody,
	type RESTPatchAPIChannelMessageJSONBody,
	type RESTPatchAPIChannelMessageResult,
	type RESTPatchAPIChannelResult,
	type RESTPostAPIChannelFollowersResult,
	type RESTPostAPIChannelInviteJSONBody,
	type RESTPostAPIChannelInviteResult,
	type RESTPostAPIChannelMessageCrosspostResult,
	type RESTPostAPIChannelMessageJSONBody,
	type RESTPostAPIChannelMessageResult,
	type RESTPostAPIChannelMessagesBulkDeleteResult,
	type RESTPostAPIChannelMessagesThreadsJSONBody,
	type RESTPostAPIChannelMessagesThreadsResult,
	type RESTPostAPIChannelThreadsJSONBody,
	type RESTPostAPIChannelTypingResult,
	type RESTPutAPIChannelMessageReactionResult,
	type RESTPutAPIChannelPermissionJSONBody,
	type RESTPutAPIChannelPermissionResult,
	type RESTPutAPIChannelPinResult,
	type RESTPutAPIChannelThreadMembersResult,
	type RESTGetAPIPollAnswerVotersQuery,
	type RESTGetAPIPollAnswerVotersResult,
	type RESTPostAPIPollExpireResult,
	MessageReferenceType,
	MessageFlags
} from "discord-api-types/v10";

import type { Readable } from "stream";
import type { ReadableStream } from "stream/web";





class ChannelMethods {









	public constructor(public requestHandler: RH, public options: ST.Options) {}











	public async getChannel(channelId: string): Promise<RESTGetAPIChannelResult> {
		return this.requestHandler.request(Endpoints.CHANNEL(channelId), {}, "get", "json");
	}
























	public async updateChannel(channelId: string, data: Omit<RESTPatchAPIChannelJSONBody, "archived" | "auto_archive_duration" | "locked" | "invitable"> & { reason?: string; }): Promise<Exclude<RESTPatchAPIChannelResult, APIThreadChannel>>;
	public async updateChannel(channelId: string, data: Pick<RESTPatchAPIChannelJSONBody, "archived" | "auto_archive_duration" | "locked" | "name" | "rate_limit_per_user"> & { reason?: string; }): Promise<Extract<RESTPatchAPIChannelResult, APIThreadChannel>>;
	public async updateChannel(channelId: string, data: RESTPatchAPIChannelJSONBody & { reason?: string; }): Promise<RESTPatchAPIChannelResult> {
		return this.requestHandler.request(Endpoints.CHANNEL(channelId), {}, "patch", "json", data);
	}


























	public async deleteChannel(channelId: string, reason?: string): Promise<RESTDeleteAPIChannelResult> {
		return this.requestHandler.request(Endpoints.CHANNEL(channelId), {}, "delete", "json", { reason });
	}





















	public async getChannelMessages(channelId: string, options: RESTGetAPIChannelMessagesQuery = { limit: 50 }): Promise<RESTGetAPIChannelMessagesResult> {
		if (options.around) {
			delete options.before;
			delete options.after;
		} else if (options.before) {
			delete options.around;
			delete options.after;
		} else if (options.after) {
			delete options.before;
			delete options.around;
		}
		if (options.limit !== undefined && (options.limit < Constants.GET_CHANNEL_MESSAGES_MIN_RESULTS || options.limit > Constants.GET_CHANNEL_MESSAGES_MAX_RESULTS)) throw new RangeError(`Amount of messages that may be requested has to be between ${Constants.GET_CHANNEL_MESSAGES_MIN_RESULTS} and ${Constants.GET_CHANNEL_MESSAGES_MAX_RESULTS}`);
		return this.requestHandler.request(Endpoints.CHANNEL_MESSAGES(channelId), options, "get", "json");
	}


















	public async getChannelMessage(channelId: string, messageId: string): Promise<RESTGetAPIChannelMessageResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_MESSAGE(channelId, messageId), {}, "get", "json");
	}













































	public async createMessage(channelId: string, data: string | RESTPostAPIChannelMessageJSONBody & { files?: Array<{ name: string; file: Buffer | Readable | ReadableStream; }> }, options: { disableEveryone?: boolean; } = { disableEveryone: this.options.disableEveryone }): Promise<RESTPostAPIChannelMessageResult> {
		if (typeof data !== "string" && !data.content && (!data.message_reference || (data.message_reference && data.message_reference.type === MessageReferenceType.Default)) && !data.embeds && !data.sticker_ids && !data.components && !data.files && !data.poll) throw new Error("Missing content, message_reference type 1, embeds, sticker_ids, components, files, or poll");
		if (typeof data === "string") data = { content: data };

		if ((data.content || data.embeds) && data.flags && (data.flags & MessageFlags.IsComponentsV2) === MessageFlags.IsComponentsV2) throw new Error("The message flags was set to include IsComponentsV2, but content and/or embeds were also present. You can either have content/embeds or components v2, not both.");


		if (data.content && (options.disableEveryone ?? this.options.disableEveryone)) data.content = Constants.replaceEveryone(data.content);
		if (data.components && (options.disableEveryone ?? this.options.disableEveryone)) data.components = Constants.replaceEveryone(data.components);
		data.allowed_mentions ??= this.options.allowed_mentions;

		if (data.files) return this.requestHandler.request(Endpoints.CHANNEL_MESSAGES(channelId), {}, "post", "multipart", await Constants.standardMultipartHandler(data as Parameters<typeof Constants["standardMultipartHandler"]>["0"]));
		else return this.requestHandler.request(Endpoints.CHANNEL_MESSAGES(channelId), {}, "post", "json", data);
	}

























	public async createVoiceMessage(channelId: string, data: Buffer, audioDurationSeconds: number, waveform = ""): Promise<RESTPostAPIChannelMessageResult> {

		const { upload_url, upload_filename } = await this.requestHandler.request(Endpoints.CHANNEL_ATTACHMENTS(channelId), {}, "post", "json", {
			files: [{
				id: "69420",
				filename: "voice-message.ogg",
				file_size: data.byteLength
			}]
		}).then(d => d.attachments[0]);


		await fetch(upload_url, { method: "PUT", body: data });


		return this.requestHandler.request(Endpoints.CHANNEL_MESSAGES(channelId), {}, "post", "json", {
			attachments: [{
				id: "42069",
				uploaded_filename: upload_filename,
				filename: "voice-message.ogg",
				duration_secs: audioDurationSeconds,
				waveform
			}],
			flags: 1 << 13
		});
	}



















	public async crosspostMessage(channelId: string, messageId: string): Promise<RESTPostAPIChannelMessageCrosspostResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_MESSAGE_CROSSPOST(channelId, messageId), {}, "post", "json");
	}



























	public async createReaction(channelId: string, messageId: string, emoji: string): Promise<RESTPutAPIChannelMessageReactionResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_MESSAGE_REACTION_USER(channelId, messageId, emoji, "@me"), {}, "put", "json") as RESTPutAPIChannelMessageReactionResult;
	}
























	public async deleteReactionSelf(channelId: string, messageId: string, emoji: string): Promise<RESTDeleteAPIChannelMessageUserReactionResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_MESSAGE_REACTION_USER(channelId, messageId, emoji, "@me"), {}, "delete", "json") as RESTDeleteAPIChannelMessageUserReactionResult;
	}



























	public async deleteReaction(channelId: string, messageId: string, emoji: string): Promise<RESTDeleteAPIChannelMessageReactionResult>;
	public async deleteReaction(channelId: string, messageId: string, emoji: string, userId: string): Promise<RESTDeleteAPIChannelMessageUserReactionResult>;
	public async deleteReaction(channelId: string, messageId: string, emoji: string, userId?: string): Promise<RESTDeleteAPIChannelMessageReactionResult | RESTDeleteAPIChannelMessageUserReactionResult> {
		return this.requestHandler.request(userId ? Endpoints.CHANNEL_MESSAGE_REACTION_USER(channelId, messageId, emoji, userId) : Endpoints.CHANNEL_MESSAGE_REACTION(channelId, messageId, emoji), {}, "delete", "json") as never;
	}




















	public async getReactions(channelId: string, messageId: string, emoji: string, options?: RESTGetAPIChannelMessageReactionUsersQuery): Promise<RESTGetAPIChannelMessageReactionUsersResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_MESSAGE_REACTION(channelId, messageId, emoji), options, "get", "json");
	}


















	public async deleteAllReactions(channelId: string, messageId: string): Promise<RESTDeleteAPIChannelAllMessageReactionsResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_MESSAGE_REACTIONS(channelId, messageId), {}, "delete", "json") as RESTDeleteAPIChannelAllMessageReactionsResult;
	}






















	public async editMessage(channelId: string, messageId: string, data: string | RESTPatchAPIChannelMessageJSONBody & { files?: Array<{ name: string; file: Buffer | Readable | ReadableStream; }> }, options: { disableEveryone?: boolean; } = { disableEveryone: this.options.disableEveryone }): Promise<RESTPatchAPIChannelMessageResult> {
		if (typeof data === "string") data = { content: data };


		if (data.content && (options.disableEveryone ?? this.options.disableEveryone)) data.content = Constants.replaceEveryone(data.content);
		if (data.components && (options.disableEveryone ?? this.options.disableEveryone)) data.components = Constants.replaceEveryone(data.components);
		if (data.content || data.components) data.allowed_mentions ??= this.options.allowed_mentions;

		if (data.files) return this.requestHandler.request(Endpoints.CHANNEL_MESSAGE(channelId, messageId), {}, "patch", "multipart", await Constants.standardMultipartHandler(data as Parameters<typeof Constants["standardMultipartHandler"]>["0"]));
		else return this.requestHandler.request(Endpoints.CHANNEL_MESSAGE(channelId, messageId), {}, "patch", "json", data);
	}



















	public async deleteMessage(channelId: string, messageId: string, reason?: string): Promise<RESTDeleteAPIChannelMessageResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_MESSAGE(channelId, messageId), {}, "delete", "json", { reason }) as RESTDeleteAPIChannelMessageResult;
	}



















	public async bulkDeleteMessages(channelId: string, messages: Array<string>, reason?: string): Promise<RESTPostAPIChannelMessagesBulkDeleteResult> {
		if (messages.length < Constants.BULK_DELETE_MESSAGES_MIN || messages.length > Constants.BULK_DELETE_MESSAGES_MAX) throw new RangeError(`Amount of messages to be deleted has to be between ${Constants.BULK_DELETE_MESSAGES_MIN} and ${Constants.BULK_DELETE_MESSAGES_MAX}`);

		const oldestSnowflake = BigInt(Date.now() - 1421280000000) * (BigInt(2) ** BigInt(22));
		const forbiddenMessage = messages.find(m => BigInt(m) < oldestSnowflake);
		if (forbiddenMessage) throw new Error(`The message ${forbiddenMessage} is older than 2 weeks and may not be deleted using the bulk delete endpoint`);
		const data = { messages };
		if (reason) Object.assign(data, { reason });
		return this.requestHandler.request(Endpoints.CHANNEL_BULK_DELETE(channelId), {}, "post", "json", data) as RESTPostAPIChannelMessagesBulkDeleteResult;
	}





















	public async editChannelPermission(channelId: string, permissionId: string, data: RESTPutAPIChannelPermissionJSONBody & { reason?: string; }): Promise<RESTPutAPIChannelPermissionResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_PERMISSION(channelId, permissionId), {}, "put", "json", data) as RESTPutAPIChannelPermissionResult;
	}
















	public async getChannelInvites(channelId: string): Promise<RESTGetAPIChannelInvitesResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_INVITES(channelId), {}, "get", "json");
	}




















	public async createChannelInvite(channelId: string, data: RESTPostAPIChannelInviteJSONBody & { reason?: string; } = { max_age: 86400, max_uses: 0, temporary: false, unique: false }): Promise<RESTPostAPIChannelInviteResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_INVITES(channelId), {}, "post", "json", data);
	}





















	public async deleteChannelPermission(channelId: string, permissionId: string, reason?: string): Promise<RESTDeleteAPIChannelPermissionResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_PERMISSION(channelId, permissionId), {}, "delete", "json", { reason }) as RESTDeleteAPIChannelPermissionResult;
	}

















	public async followAnnouncementChannel(channelId: string, webhookChannelId: string): Promise<RESTPostAPIChannelFollowersResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_FOLLOWERS(channelId), {}, "post", "json", { webhook_channel_id: webhookChannelId });
	}



















	public async startChannelTyping(channelId: string): Promise<RESTPostAPIChannelTypingResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_TYPING(channelId), {}, "post", "json") as RESTPostAPIChannelTypingResult;
	}
















	public async getChannelPinnedMessages(channelId: string): Promise<RESTGetAPIChannelPinsResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_PINS(channelId), {}, "get", "json");
	}




















	public async addChannelPinnedMessage(channelId: string, messageId: string, reason?: string): Promise<RESTPutAPIChannelPinResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_PIN(channelId, messageId), {}, "put", "json", { reason }) as RESTPutAPIChannelPinResult;
	}




















	public async removeChannelPinnedMessage(channelId: string, messageId: string, reason?: string): Promise<RESTDeleteAPIChannelPinResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_PIN(channelId, messageId), {}, "delete", "json", { reason }) as RESTDeleteAPIChannelPinResult;
	}



















	public async createThreadWithMessage(channelId: string, messageId: string, options: RESTPostAPIChannelMessagesThreadsJSONBody & { reason?: string; }): Promise<RESTPostAPIChannelMessagesThreadsResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_MESSAGE_THREADS(channelId, messageId), {}, "post", "json", options);
	}



















	public async createThreadWithoutMessage(channelId: string, options: Omit<RESTPostAPIChannelThreadsJSONBody, "type"> & { type: 10; reason?: string; }): Promise<APITextBasedChannel<ChannelType.AnnouncementThread>>;
	public async createThreadWithoutMessage(channelId: string, options: Omit<RESTPostAPIChannelThreadsJSONBody, "type"> & { type: 11; reason?: string; }): Promise<APITextBasedChannel<ChannelType.PublicThread>>;
	public async createThreadWithoutMessage(channelId: string, options: Omit<RESTPostAPIChannelThreadsJSONBody, "type"> & { type: 12; reason?: string; }): Promise<APITextBasedChannel<ChannelType.PrivateThread>>;
	public async createThreadWithoutMessage(channelId: string, options: RESTPostAPIChannelThreadsJSONBody & { reason?: string; }): Promise<APITextBasedChannel<ChannelType.PublicThread | ChannelType.PrivateThread | ChannelType.AnnouncementThread>> {
		return this.requestHandler.request(Endpoints.CHANNEL_THREADS(channelId), {}, "post", "json", options);
	}















	public async joinThread(threadId: string): Promise<RESTPutAPIChannelThreadMembersResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_THREAD_MEMBER(threadId, "@me"), {}, "put", "json") as RESTPutAPIChannelThreadMembersResult;
	}



















	public async addThreadMember(threadId: string, userId: string): Promise<RESTPutAPIChannelThreadMembersResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_THREAD_MEMBER(threadId, userId), {}, "put", "json") as RESTPutAPIChannelThreadMembersResult;
	}











	public async leaveThread(threadId: string): Promise<RESTDeleteAPIChannelThreadMembersResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_THREAD_MEMBER(threadId, "@me"), {}, "delete", "json") as RESTDeleteAPIChannelThreadMembersResult;
	}
















	public async removeThreadMember(threadId: string, userId: string): Promise<RESTDeleteAPIChannelThreadMembersResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_THREAD_MEMBER(threadId, userId), {}, "delete", "json") as RESTDeleteAPIChannelThreadMembersResult;
	}

















	public async getThreadMember(threadId: string, userId: string, withMember?: boolean): Promise<RESTGetAPIChannelThreadMemberResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_THREAD_MEMBER(threadId, userId), { with_member: withMember }, "get", "json");
	}




















	public async getThreadMembers(channelId: string, options?: RESTGetAPIChannelThreadMembersQuery): Promise<RESTGetAPIChannelThreadMembersResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_THREAD_MEMBERS(channelId), options, "get", "json");
	}

















	public async getChannelArchivedPublicThreads(channelId: string, options?: RESTGetAPIChannelThreadsArchivedQuery): Promise<RESTGetAPIChannelThreadsArchivedPublicResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_THREADS_ARCHIVED_PUBLIC(channelId), options, "get", "json");
	}




















	public async getChannelArchivedPrivateThreads(channelId: string, options?: RESTGetAPIChannelThreadsArchivedQuery): Promise<RESTGetAPIChannelThreadsArchivedPrivateResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_THREADS_ARCHIVED_PRIVATE(channelId), options, "get", "json");
	}


















	public async getChannelArchivedPrivateThreadsUser(channelId: string, options?: RESTGetAPIChannelThreadsArchivedQuery): Promise<RESTGetAPIChannelUsersThreadsArchivedResult> {
		return this.requestHandler.request(Endpoints.CHANNEL_THREADS_ARCHIVED_PRIVATE_USER(channelId), options, "get", "json");
	}











	public async refreshAttachmentURLs(attachments: string | Array<string>): Promise<RESTPostAPIAttachmentsRefreshURLsResult> {
		return this.requestHandler.request(Endpoints.ATTACHMENTS_REFRESH_URLS, {}, "post", "json", {
			attachment_urls: Array.isArray(attachments) ? attachments : [attachments]
		});
	}















	public async getPollAnswerVoters(channelId: string, messageId: string, answerId: string, options?: RESTGetAPIPollAnswerVotersQuery): Promise<RESTGetAPIPollAnswerVotersResult> {
		return this.requestHandler.request(Endpoints.POLL_ANSWER(channelId, messageId, answerId), options, "get", "json");
	}













	public async endPoll(channelId: string, messageId: string): Promise<RESTPostAPIPollExpireResult> {
		return this.requestHandler.request(Endpoints.POLL_EXPIRE(channelId, messageId), {}, "post", "json");
	}
}

export = ChannelMethods;







